import React, { useState, useEffect, useCallback } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const Hero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const slides = [
      { image: '/images/top-image.jpeg', title: 'ものづくりの未来をサポート', subtitle: '最先端の工作機械と専門知識で、地域産業の発展に貢献' },
      { image: '/images/top-image2.jpeg', title: 'Precision Meets Innovation', subtitle: '高精度切削工具で、製品品質と生産効率を同時に実現' },
      { image: '/images/top-image3.jpeg', title: '日本のものづくり、さらなる高みへ', subtitle: '国内トップブランドの工作機械で、地域企業の競争力を強化' },
    ];
  
    const nextSlide = useCallback(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, [slides.length]);

    useEffect(() => {
      const timer = setInterval(nextSlide, 5000);
      return () => clearInterval(timer);
    }, [nextSlide]);
  
    return (
      <section className="relative h-[calc(100vh-4rem)] sm:h-[calc(100vh-5rem)] w-full overflow-hidden bg-gray-100" aria-label="ヒーローセクション">
        <AnimatePresence initial={false}>
          <motion.div
            key={currentSlide}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            className="absolute inset-0 flex items-center justify-center"
          >
            <div className="relative w-full h-full flex items-center justify-center">
              <img 
                src={slides[currentSlide].image} 
                alt={slides[currentSlide].title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
              <div className="text-center px-4 max-w-4xl">
                <motion.h2 
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-2 sm:mb-4 text-white drop-shadow-lg"
                >
                  {slides[currentSlide].title}
                </motion.h2>
                <motion.p
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  className="text-lg sm:text-xl md:text-2xl text-white drop-shadow-md"
                >
                  {slides[currentSlide].subtitle}
                </motion.p>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </section>
    );
};

export default Hero;